module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.className
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(" " + _vm._s(_vm.item.label) + " ")]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control margin-bottom",
    attrs: {
      "placeholder": _vm.item.placeholder,
      "name": _vm.item.name,
      "maxlength": _vm.item.maxlength,
      "cols": _vm.item.cols,
      "rows": _vm.item.rows,
      "readonly": _vm.item.readonly
    },
    domProps: {
      "value": _vm.item.value
    },
    on: {
      "input": _vm.update
    }
  }), _vm._v(" "), _vm._l((_vm.item.errors), function(error) {
    return _c('div', {
      staticClass: "to-up",
      class: {
        'margin-left': _vm.item.type == 'checkbox'
      },
      attrs: {
        "id": "errors"
      }
    }, [_vm._v("\n        " + _vm._s(error) + "\n    ")])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6c44992"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/input-components/emt-textarea.vue
// module id = 101
// module chunks = 0